
import { supabase } from "@/lib/supabase";
import { useToast } from "@/hooks/use-toast";
import { useOnlineStatus } from "@/hooks/use-online-status";

export const useTaskActions = (fetchTasks: () => Promise<void>) => {
  const { toast } = useToast();
  const isOnline = useOnlineStatus();

  const handleDelete = async (taskId: string) => {
    try {
      if (!isOnline) {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) return;

        await supabase.from('offline_sync').insert({
          task_id: taskId,
          operation: 'delete',
          user_id: session.user.id,
          offline_id: `delete_${taskId}_${Date.now()}`
        });

        toast({
          title: "Gemt offline",
          description: "Opgaven vil blive slettet når du kommer online igen."
        });
      } else {
        const { error } = await supabase
          .from('tasks')
          .delete()
          .eq('id', taskId);

        if (error) throw error;

        toast({
          title: "Opgave slettet",
          description: "Opgaven er blevet slettet succesfuldt."
        });
      }

      fetchTasks();
    } catch (error) {
      console.error('Fejl ved sletning af opgave:', error);
      toast({
        title: "Fejl ved sletning",
        description: "Der opstod en fejl ved sletning af opgaven.",
        variant: "destructive"
      });
    }
  };

  return {
    handleDelete
  };
};
